import { useEffect } from "react";
import { useCart } from "@/context/CartContext";
import api from "@/lib/api";

// Logs one anonymous website visit per browser session, attributed to the visitor's
// selected branch, so branch admins can see their own traffic under Analytics.
export const VisitTracker = () => {
  const { selectedBranch } = useCart();
  useEffect(() => {
    const path = window.location.pathname || "";
    if (/^\/(admin|super|staff)/.test(path)) return;
    if (sessionStorage.getItem("metros_visit_logged")) return;
    let vid = localStorage.getItem("metros_visitor_id");
    if (!vid) {
      vid = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("metros_visitor_id", vid);
    }
    sessionStorage.setItem("metros_visit_logged", "1");
    api.post("/track/visit", { visitor_id: vid, branch_id: selectedBranch?.id || null }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
